
import { computed, defineComponent, onBeforeMount, reactive, toRaw, watch } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheTime from '@/common/components/UI/TheTime/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// constants
import { FT_CREATE_TYPES } from '@/core/constants/ftl_types.constants'

// composable
import useAccount from '@/common/composable/useAccount'

export default defineComponent({
    components: {
        TheInput,
        TheTime,
        TheButton,
        TheSelect,
    },
    props: {
        opened: {
            type: Boolean,
            default: false,
        },
        stepNumber: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        takeDate: {
            type: String,
            default: null,
        },
        takeTime: {
            type: String,
            default: null,
        },
    },
    emits: ['submit', 'reset', 'excel-multiple-order'],
    setup(props, { emit }) {
        const { havePermissions } = useAccount()

        const minDate = new Date().toISOString().split('T')[0]

        const state = reactive({
            is_selected: false,
            ftl_type: '2',
            take_date: null as string | null,
            take_time: null as string | null,
        })

        const emitSubmit = () => {
            state.is_selected = true

            emit(
                'submit',
                toRaw({
                    ftl_type: Number(state.ftl_type),
                    take_date: state.take_date,
                    take_time: state.take_time,
                })
            )
        }

        const emitReset = () => {
            state.is_selected = false
            state.take_date = null
            state.take_time = null

            emit('reset')
        }

        const emitExcelOrder = () => {
            emit('excel-multiple-order')
        }

        watch(
            () => props.opened,
            (opened) => {
                if (!opened) {
                    state.is_selected = false
                    state.take_date = null
                    state.take_time = null
                }
            }
        )

        const getTypeName = computed(() => {
            return FT_CREATE_TYPES.find((type) => type.id === state.ftl_type)?.name || 'Без типа'
        })

        const isValidForm = computed(
            () => !state.take_date || !state.take_time || state.take_time?.length < 5
        )

        onBeforeMount(() => {
            state.take_date = props.takeDate
            state.take_time = props.takeTime
        })

        const maxDate = computed(() => {
            const date = new Date()
            date.setFullYear(date.getFullYear() + 1)
            return date.toISOString().split('T')[0]
        })

        return {
            havePermissions,
            state,
            emitSubmit,
            emitReset,
            emitExcelOrder,
            getTypeName,
            isValidForm,
            FT_CREATE_TYPES,
            minDate,
            maxDate
        }
    },
})
